import { AfterViewInit, Component, Input, OnDestroy } from '@angular/core';

import { BaseUI } from '../../base.ui';
import { Client } from '../../../domain/data';
import { ParentEvents } from '../../../utils/parent-events.service';

@Component({
    selector: 'thr-contract-form-natural-person',
    templateUrl: './contract-form-natural-person.component.html',
    styleUrls: ['./contract-form-natural-person.component.scss'],
})
export class ContractFormNaturalPersonComponent extends BaseUI implements AfterViewInit, OnDestroy {
    @Input()
    client: Client;

    constructor(parentEvents: ParentEvents) {
        super(parentEvents);
    }
}
